<template>
  <alerts-template>
    <template slot="alert-type-heading">{{ this.name }}</template>
    <template slot="alert-type-count">
      <h6 class="mb-0" v-if="this.data.length > 0">[<span class="text-danger">{{ this.data.filter(alert => alert.level === 0).length }}</span> / <span class="text-warning">{{ this.data.filter(alert => alert.level === 1).length }}</span>]</h6>
      <h6 class="mb-0" v-else>[<span class="text-green">0</span>]</h6>
    </template>
    <template slot="alert-type-toggle">
      <button class="btn btn-gray btn-toggle" @click="toggleAlerts">
        <img v-bind:class="[isHidden ? '' : 'rotated']" src="/app/images/icons/toggle.svg">
      </button>
    </template>
    <template slot="alert-type-info">
      <div v-show="!isHidden">
        <div v-if="this.data.length > 0">
          <div class="d-flex align-items-center pb-4 mb-2" v-for="(alert, index) in this.data" v-bind:key="index">
            <img v-if="alert.level === 0" class="icon-small" v-bind:src="'/app/images/icons/warning_danger.svg'" />
            <img v-else class="icon-small" v-bind:src="'/app/images/icons/warning.svg'" />
            <div class="d-flex justify-content-between align-items-center w-100">
              <div>
                <p class="mb-1 mx-4"><span>{{ alert.message }}</span></p>
                <p class="mb-0 mx-2">
                  <strong v-if="id === 'source'" class="mx-3">plik: {{ sources.filter(source => source.id === alert.sourceId)[0].name }}</strong>
                </p>
              </div>
              <div v-if="id === 'feed'" class="pr-4">
                <router-link :to="{ name: 'feed.details', params: { id: $route.params.id, feedId: alert.feedId }}">
                  <info-icon class="mr-3"></info-icon>
                  <u>{{ $t('global.check_errors') }}</u>
                </router-link>
              </div>
              <div v-else-if="id === 'source'" class="pr-4">
                <router-link :to="{ name: 'source.edit', params: { projectId: $route.params.id, sourceId: alert.sourceId }}">
                  <edit-icon class="mr-3"></edit-icon>
                  <u>{{ $t('global.check_sources') }}</u>
                </router-link>
              </div>
            </div>
          </div>
          <div v-if="this.id === 'source'" class="mt-4 mb-0">
            <router-link :to="{ name: 'sources', params: { id: $route.params.id }}">
              <button class="btn btn-large btn-orange-dark">
                <settings-icon></settings-icon>
                <span>{{ $t('sources.source_files_optimization') }}</span>
              </button>
            </router-link>
          </div>
          <div v-else-if="this.id === 'feed'" class="mt-4 mb-0">
            <router-link :to="{ name: 'feeds', params: { id: $route.params.id }}">
              <button class="btn btn-large btn-orange-dark">
                <settings-icon></settings-icon>
                <span>{{ $t('feeds.feeds_optimization') }}</span>
              </button>
            </router-link>
          </div>
        </div>
        <div v-else class="d-flex align-items-center">
          <img class="icon-small" v-bind:src="'/app/images/icons/success.svg'" />
          <p class="mb-0 mx-4">{{$t('global.no_alerts')}}</p>
        </div>
      </div>
    </template>
  </alerts-template>
</template>

<script>
import AlertsTemplate from '@/views/Alerts'
import { EditIcon, InfoIcon, SettingsIcon } from 'vue-feather-icons'

export default {
  name: 'AlertTypeSummary',

  data () {
    return {
      isHidden: false
    }
  },

  props: {
    data: { required: false, type: Array },
    id: { required: false, type: String },
    name: { required: false, type: String },
    sources: { required: false, type: Array }
  },

  methods: {
    toggleAlerts () {
      this.isHidden = !this.isHidden
    }
  },

  components: { AlertsTemplate, EditIcon, InfoIcon, SettingsIcon }
}
</script>
